module.exports = __webpack_public_path__ + "6f55030e14a7649ce0874f66c22e3af0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/logo_title_white.svg
// module id = 583
// module chunks = 1